import { Component, Input, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-technical-issue-message',
  templateUrl: './technical-issue-message.component.html',
  styleUrls: ['./technical-issue-message.component.scss']
})
export class TechnicalIssueMessageComponent implements OnInit {
  @Input() tryAgainURL!: string;

  constructor() { }

  ngOnInit(): void {
  }

  tryAgain(): void {
    window.location.href = this.tryAgainURL;
  }

}
